export * from './core.module';
export * from './i18n.service';
export * from './http/http.service';
export * from './http/http-cache.service';
export * from './logger.service';



// WEBPACK FOOTER //
// ./src/app/core/index.ts